import { closeModal } from 'actions/app'

import ModalTool from 'components/modal/modal-tool'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useCallback, type ReactElement } from 'react'

import { editTenantPreferences } from 'api/tenant'

interface UnlinkIntegrationProps {
  onResult: (result: 'apply' | 'close') => void
  integrationName: string
}

export default function UnlinkIntegration({
  onResult,
  integrationName,
}: UnlinkIntegrationProps): ReactElement<any, any> {
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const closePopup = useCallback(() => {
    dispatch(closeModal())
    onResult('close')
  }, [dispatch, onResult])

  const onApply = useCallback(() => {
    dispatch(closeModal())
    onResult('apply')
  }, [dispatch, onResult])

  return (
    <ModalTool
      header={t('unlink_integration', { integration_name: integrationName })}
      content={
        <>
          <p>
            {t('unlink_integration_confirmation', {
              integration_name: integrationName,
            })}
          </p>
        </>
      }
      onClose={closePopup}
      onApply={onApply}
      applyTranslationKey="yes"
      closeTranslationKey="no"
    />
  )
}
